/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { computed } from '@ember/object';

export default class AttendanceRoute extends Route {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  @computed('dates.previousPreviousAcademicYearLabel')
  get previousPreviousAcademicDates() {
    let previousPreviousYear = this.dates.previousPreviousAcademicYearLabel;
    let academicYearDates =
      this.dates.halfyearDatesForAcademicYear(previousPreviousYear);
    return {
      startDate: academicYearDates.startDate.format('YYYY-MM-DD'),
      endDate: academicYearDates.endDate.format('YYYY-MM-DD'),
    };
  }

  @computed('dates.currentAcademicYearLabel')
  get currentAcademicDates() {
    let currentYear = this.dates.currentAcademicYearLabel;
    let academicYearDates =
      this.dates.halfyearDatesForAcademicYear(currentYear);
    return {
      startDate: academicYearDates.startDate.format('YYYY-MM-DD'),
      endDate: academicYearDates.endDate.format('YYYY-MM-DD'),
    };
  }

  model() {
    return hash({
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
      timetable: this.store.query('timetable/structure', {
        schoolId: this.get('session.school.id'),
      }),
      dates: this.store.query('date', {
        from: this.previousPreviousAcademicDates.startDate,
        to: this.currentAcademicDates.endDate,
      }),
    });
  }
}
